(function () {
    if (!window.location.pathname.includes("/cart")) return;

    const hide = () => {
        document.querySelector("#wheelify-spin_a_sale_cc_store_front_module")?.style.setProperty("display", "none");
        document.querySelector("#wheelify-spin-trigger-cc")?.style.setProperty("display", "none");
    };

    hide();

    new MutationObserver(hide).observe(document.documentElement, {
        childList: true,
        subtree: true
    });
})();
